export default __webpack_public_path__ + "media/images/preview-e93ce54a4be3bae054b5e0badcbfcbfc.png";